import { createFileRoute } from '@tanstack/react-router'
import { FleetSection } from '@spcc/domains/assets'

export const Route = createFileRoute('/fleet/vehicles')({
  component: FleetVehiclesPage,
})

function FleetVehiclesPage() {
  return <FleetSection activeTab="vehicles" />
}
